import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import axios from 'axios';

import '../Login/login.css';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

function AlterarSenha() {
    const history = useHistory();
    const [senha, setSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [alter, setAlter] = useState('N');
    const [mensagemErro, setMensagemErro] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [mostrarConfirmar, setMostrarConfirmar] = useState(false);

    const calcForca = (val) => {
        if (!val) return 0;
        let pontos = 0;
        if (val.length >= 8) pontos++;
        if (/[A-Z]/.test(val) && /[a-z]/.test(val)) pontos++;
        if (/\d/.test(val) && /[^A-Za-z0-9]/.test(val)) pontos++;
        return Math.min(pontos, 3);
    };
    const forca = calcForca(senha);
    const forcaLabel = ['', 'Fraca', 'Média', 'Forte'][forca];

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) {
            history.push("/");
        }
    };

    function verificaSenha() {
        if (!senha || senha.trim().length === 0) {
            setMensagemErro('A senha deve ser preenchida.');
            return false;
        }
        if (senha !== confirmar) {
            setMensagemErro('As senhas não coincidem.');
            return false;
        }
        if (senha.length < 8) {
            setMensagemErro('A senha deve conter ao menos 8 caracteres.');
            return false;
        }
        setMensagemErro('');
        return true;
    }

    function fncSair() {
        localStorage.setItem('codUsu', 0);
        localStorage.setItem("logado", "N");
    }

    const updateUsuario = async (e) => {
        e.preventDefault();
        setMensagemErro('');
        if (!verificaSenha()) return;

        verificandoToken();
        const token = localStorage.getItem('token');
        const baseUrl = ensureProtocol(localStorage.getItem("ipBackend2"));

        if (!baseUrl) {
            setMensagemErro('Backend não configurado.');
            return;
        }

        setCarregando(true);
        try {
            await axios.put(baseUrl + "/usuarios", {
                usrSis: localStorage.getItem('codUsu'),
                senha
            }, {
                headers: { Authorization: `${token}` }
            });
            fncSair();
            setAlter('S');
        } catch (error) {
            const msg = error?.response?.data?.message || error?.response?.data?.error || 'Erro ao alterar senha. Tente novamente.';
            setMensagemErro(msg);
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        verificar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (alter === 'S') {
        return <Redirect to="/" />;
    }

    return (
        <div className="login-page">
            <section className="login-brand">
                <span className="login-orb login-orb--1" aria-hidden="true" />
                <span className="login-orb login-orb--2" aria-hidden="true" />
                <div className="login-brand-inner">
                    <Link to="/">
                        <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" className="login-logo" />
                    </Link>
                    <p className="login-tagline">Central de atendimento e chamados. Altere sua senha para manter a segurança do acesso.</p>
                    <ul className="login-features">
                        <li><i className="fas fa-lock" /> Use ao menos 8 caracteres</li>
                        <li><i className="fas fa-font" /> Misture maiúsculas e minúsculas</li>
                        <li><i className="fas fa-hashtag" /> Inclua números e símbolos</li>
                    </ul>
                </div>
            </section>
            <div className="login-form-wrap">
                <div className="login-form-card">
                    <h2><i className="fas fa-key" /> Alterar senha</h2>
                    <p className="subtitle">Informe e confirme sua nova senha (mínimo 8 caracteres).</p>
                    <form onSubmit={updateUsuario}>
                        <div className="login-field">
                            <label htmlFor="alterar-nova-senha">Nova senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="alterar-nova-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    placeholder="Nova senha"
                                    autoComplete="new-password"
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-senha"
                                    onClick={() => setMostrarSenha((v) => !v)}
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    tabIndex={-1}
                                >
                                    <i className={mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'} />
                                </button>
                            </div>
                            {senha && (
                                <div className={`login-forca login-forca--${forca}`}>
                                    <span /><span /><span />
                                    <small>{forcaLabel}</small>
                                </div>
                            )}
                        </div>
                        <div className="login-field">
                            <label htmlFor="alterar-confirmar-senha">Confirmar senha</label>
                            <div className="login-input-wrap">
                                <i className="fas fa-lock login-input-icon" />
                                <input
                                    id="alterar-confirmar-senha"
                                    type={mostrarConfirmar ? 'text' : 'password'}
                                    value={confirmar}
                                    onChange={(e) => setConfirmar(e.target.value)}
                                    placeholder="Confirmar senha"
                                    autoComplete="new-password"
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-senha"
                                    onClick={() => setMostrarConfirmar((v) => !v)}
                                    aria-label={mostrarConfirmar ? 'Ocultar senha' : 'Mostrar senha'}
                                    tabIndex={-1}
                                >
                                    <i className={mostrarConfirmar ? 'fas fa-eye-slash' : 'fas fa-eye'} />
                                </button>
                            </div>
                        </div>
                        {mensagemErro && (
                            <div className="login-alert login-alert--error" role="alert">
                                <i className="fas fa-circle-exclamation" /> <strong>{mensagemErro}</strong>
                            </div>
                        )}
                        <button type="submit" className="login-submit" disabled={carregando}>
                            {carregando ? <><span className="sol-spinner" /> Alterando...</> : <>Alterar senha <i className="fas fa-check" /></>}
                        </button>
                    </form>
                    <footer className="login-footer">
                        <div className="login-footer-line">
                            <Link to="/home">Não quero alterar</Link>
                        </div>
                        <div className="login-footer-line">
                            <Link to="/preferenciasAtendimento" className="login-link-preferencias">
                                <i className="fas fa-play-circle" /> Configurar status Play/Pause
                            </Link>
                        </div>
                        <div className="login-footer-line">
                            &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default AlterarSenha;
